export const GreenCheckIcon = ({width = 32, height = 32}) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="12" fill="#2F8370" /> <path d="M14.75 21.75L9.5 16.25L10.25 15.25L14.5 18.25L21.75 11L22.75 12L14.75 21.75Z" fill="white" />
    </svg>
  );